export default __webpack_public_path__ + "static/media/walkthrough-step3-fullHD.0cbd4153.jpg";